import StatusDot from '@/components/ui/StatusDot.tsx';
import { PlannedTransactionPaymentStatus } from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.ts';
import {
  PLANNED_TRANSACTION_PAYMENT_STATUS_TONE,
  getPlannedTransactionPaymentStatusLabel,
} from '@/features/public/bookingSummary/types/PlannedTransactionPaymentStatus.utils.ts';

const PaymentStatusIndicator = ({
  status,
}: {
  status: PlannedTransactionPaymentStatus;
}) => (
  <StatusDot
    tone={PLANNED_TRANSACTION_PAYMENT_STATUS_TONE[status]}
    label={getPlannedTransactionPaymentStatusLabel(status)}
    className="text-sm"
  />
);

export default PaymentStatusIndicator;
